<template>
    <div
        v-if="currentImage || currentImageWebp"
        :class="{
            'aspect-[1.95]': size === 'small',
            'col-span-2 aspect-[3.38]': size === 'big' && align === 'row',
            'row-span-2': size === 'big' && align === 'col',
            'invisible !absolute animate-fade-scale-close': !currentImage,
            'animate-fade-scale-open': currentImage,
        }"
        class="relative flex size-full items-center justify-center overflow-hidden rounded-12">
        <picture
            v-show="currentImage || currentImageWebp"
            class="h-3/4">
            <source
                type="image/webp"
                :srcset="currentImageWebp || ''" />

            <img
                loading="lazy"
                alt="product image"
                :src="currentImage || ''"
                :class="
                    isAnimate
                        ? 'animate-fade-scale-close'
                        : 'animate-fade-scale-open'
                "
                class="size-full object-contain" />
        </picture>

        <div
            :class="{
                'opacity-0': hideCount || !props.image,
            }"
            class="absolute bottom-3 right-3 flex aspect-square h-12 items-center justify-center rounded-8 bg-calculator-form p-2 text-32/100 font-semibold transition-opacity duration-300">
            <AtomIcon
                v-if="successIcon"
                name="success"
                class="size-6" />
            <span v-else>{{ count }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'

const props = defineProps({
    image: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    imageWebp: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    size: {
        type: String as PropType<'small' | 'big'>,
        default: 'small',
    },
    align: {
        type: String as PropType<'row' | 'col'>,
        default: 'row',
    },
    count: {
        type: [String, Number] as PropType<number | string>,
        default: 0,
    },
    successIcon: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    hideCount: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const isAnimate = ref<boolean>(false)
const currentImage = ref<string | null>(null)
const currentImageWebp = ref<string | null>(null)

watch(
    () => props.image,
    () => {
        isAnimate.value = true

        setTimeout(() => {
            currentImage.value = props.image
            currentImageWebp.value = props.imageWebp
            isAnimate.value = false
        }, 300)
    }
)

onMounted(() => {
    currentImage.value = props.image
    currentImageWebp.value = props.imageWebp
})
</script>
